<!--
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-20 15:52:14
 * @LastEditTime: 2020-08-13 10:17:01
-->
<template>
  <div class="filter">
    <div class="filter-box">
      <label>参会ID：</label>
      <Input v-model="filter.id" placeholder="请输入" style="width:150px"></Input>
    </div>
    <div class="filter-box">
      <label>姓名：</label>
      <Input v-model="filter.name" placeholder="请输入" style="width:150px"></Input>
    </div>
    <div class="filter-box">
      <label>电话：</label>
      <Input v-model="filter.telphone" placeholder="请输入" style="width:150px"></Input>
    </div>
    <div class="filter-box">
      <label>单位类型：</label>
      <Select v-model="filter.unitType" style="width:150px">
        <Option
          v-for="item in cityList"
          :value="item.value"
          :key="item.value">
          {{item.label}}
        </Option>
      </Select>
    </div>
    <div class="filter-box">
      <label>入驻酒店：</label>
      <Input v-model="filter.hotelName" placeholder="请输入" style="width:150px"></Input>
    </div>
    <div class="filter-box">
      <label>入住时间：</label>
      <DatePicker
        type="date"
        v-model="filter.startTime"
        :disabled="unitTypeTime"
        :placeholder="placeTitle"
        style="width: 150px"></DatePicker>
      <label class="centerLine">-</label>
      <DatePicker
        type="date"
        v-model="filter.endTime"
        :disabled="unitTypeTime"
        :placeholder="placeTitle"
        style="width: 150px"></DatePicker>
    </div>
    <div class="filter-box">
      <label>离店时间：</label>
      <DatePicker
        type="date"
        v-model="filter.departureTime"
        :disabled="unitTypeTime"
        :placeholder="placeTitle"
        style="width: 150px"></DatePicker>
    </div>
    <div class="filter-box">
      <Button type="primary" @click="search">搜索</Button>
      <Button @click="goReset">重置</Button>
      <Button type="primary" @click="exportData">导出</Button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      unitTypeTime: false,
      placeTitle: '请选择时间',
      filter: {
        id: '', //参会ID
        name: '', //姓名
        telphone: '', //电话
        unitType: '', //单位时间
        hotelName: '', //入驻酒店
        startTime: new Date(), //时间开始
        endTime: new Date(), //时间结束
        departureTime: new Date(),
      },
      cityList: [
        {
          value: '1',
          label: '政府',
        },
        {
          value: '2',
          label: '企业',
        },
      ],
    }
  },
  watch: {
    'filter.unitType'(v) {
      if (v === '2') {
        this.filter.startTime = ''
        this.filter.endTime = ''
        this.filter.departureTime = ''
        this.unitTypeTime = true
      } else {
        this.filter.startTime = this.$moment(new Date()).format('YYYY-MM-DD hh:mm:ss') //时间开始
        this.filter.endTime = this.$moment(new Date()).format('YYYY-MM-DD hh:mm:ss') //时间结束
        this.filter.departureTime = this.$moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        this.unitTypeTime = false
      }
    },
  },
  methods: {
    goReset() {
      this.filter = {
        id: '', //参会ID
        name: '', //姓名
        telphone: '', //电话
        unitType: '', //单位时间
        hotelName: '', //入驻酒店
        startTime: this.$moment(new Date()).format('YYYY-MM-DD hh:mm:ss'), //时间开始
        endTime: this.$moment(new Date()).format('YYYY-MM-DD hh:mm:ss'), //时间结束
        departureTime: this.$moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
      }
      this.$emit('reset', this.filter)
    },
    search() {
      this.$emit('query', this.filter)
    },
    exportData() {
      this.$emit('exportData')
    },
  },
}
</script>

<style lang='scss' scoped>
.filter {
  display: flex;
  flex-wrap: wrap;
justify-content: flex-start;
  > .filter-box {
    margin: 0px 10px 10px 0px;
    button {
      margin-right: 10px;
    }
    label {
      width: 70px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #666666;
      line-height: 20px;
    }
    .centerLine {
      margin: 0 10px;
    }
  }
}
</style>